export const publicRoutes = [
  '/login',
  '/signup',
  '/sent-email',
  '/activate',
  '/resetpassword',
  '/success',
  '/activate-failed',
  '/forgot-password',
  '/verify-mfa',
  '/sso-activation',
];
